/**
 * An action bar that is not there — for the height of one that will be.
 *
 * In portrait the action band sits under the hero and the stage takes what is left, so
 * the felt is exactly as tall as the band is short. Phase 2 gave the band a floor so it
 * would not collapse to nothing between turns; the Director made the rest of the
 * problem visible: the bar with its pills and slider is some 130px taller than that
 * floor, so the felt shrank by twelve pixels and every seat moved the moment it became
 * the player's turn, and moved back when they acted. On every hand.
 *
 * So when the real bar is absent this stands in its place: the same component, the same
 * rows, `visibility: hidden` and `inert`, so the band is the same height whether or not
 * it is the player's turn and the felt above it never learns the difference. In
 * landscape the band is an overlay and this is `display: none` — see `topdown.css`.
 *
 * The legal actions are a stand-in set with the widest layout the bar produces (four
 * buttons and the sizing row); nothing here is clickable or announced.
 */
import type { Action } from "@engine/types";
import { ActionBar } from "../components/ActionBar";

const GHOST_LEGAL: Action[] = [
  { kind: "fold" }, { kind: "call", to: 1 }, { kind: "raise", to: 3 }, { kind: "allin", to: 100 },
];

export function GhostActionBar({ bigBlind, chipSize }: { bigBlind: number; chipSize: number }) {
  return (
    <div className="abar-ghost" inert aria-hidden="true">
      <ActionBar
        spotId="ghost" legal={GHOST_LEGAL} pot={3} toCall={1} committed={0} stack={100}
        chipSize={chipSize} bigBlind={bigBlind} busy variant="topdown" onAct={() => {}}
      />
    </div>
  );
}
